/**
 * PosicaoMotoristaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {PosicaoMotorista} from '@/model/resource/PosicaoMotorista'

/* TODO: review generated class */
@HttpExclude()
export class PosicaoMotoristaCollection extends PageCollection<
  PosicaoMotorista
> {
  constructor() {
    super(PosicaoMotorista)
  }

  queryAsPage() {
    return this.listPosicaoMotorista()
  }

  async listPosicaoMotorista() {
    return await Request.get(`/admin/posicao-motorista`, {params: this.params})
      .name('listPosicaoMotorista')
      .as(this)
      .getResponse()
  }

  async listCsvPosicaoMotorista() {
    return await Request.get(`/admin/posicao-motorista/csv`, {
      params: this.params,
    })
      .name('listCsvPosicaoMotorista')
      .as(this)
      .getResponse()
  }
}
